import React, { Fragment, useEffect, useState } from 'react';
import { get, post } from '../../../Services/http';
import { translate } from '../../../Services/translation';
import { ValidatePhone } from '../../../Services/phonevalidation';
import { backendStoreName } from '../../Services/Api.service';

const GDPRApprovalRequest = () => {
    const [topContent, settopContent] = useState('');
    const [phone, setphone] = useState('');
    const [sentSuccess, setsentSuccess] = useState(false);
    const [errorMessage, seterrorMessage] = useState('');    

    useEffect(() => {
        get(`/api/gdprapproval`)
            .then((response) => response.json())
            .then((result) => {
                settopContent(result ? result.value : "");
            });
    }, []);

    const ValidateAndSendLink = () => {
        if (ValidatePhone(phone)) {
            post(`/api/gdprapproval/checkifphoneisvalid`, {
                phoneNumber: phone,
              })
            .then((response) => response.json())
            .then((result) => {
                if (result.value !== "") {   
                    seterrorMessage(translate('coptikk.validation.alreadyexists'));  
                    setsentSuccess(false);               
                }
                else {
                    seterrorMessage("");
                    post(`/api/gdprapproval`, {
                        phoneNumber: phone,
                        storeName: backendStoreName(),
                    })
                        .then(() => {
                            setsentSuccess(true);
                        })
                        .catch(error => {
                            seterrorMessage(translate('coptikk.login.errorsendingsms'));
                        });;                    
                }  
            });                     
        } else {
            setsentSuccess(false);
            seterrorMessage(translate("coptikk.login.invalidphonenumber"));
        }
    }

    return (
        <Fragment>
            <div className='row gdpr-page'>
                <div className='column medium-6 small-12'>
                    <h2>
                        {translate("coptikk.adminportal.gdprapproval.requestheader")}
                    </h2>
                </div>
            </div>
            <div className='row gdpr-page'>
                <div className='column medium-6 small-12' dangerouslySetInnerHTML={{ __html: topContent }}></div>
            </div>
            {errorMessage && <div className='codelogin__error'>
                {errorMessage}
            </div>
            }
            <div className='row gdpr-page'>
                <div className='column medium-6 small-12'>
                    <label>{translate("coptikk.login.phone")}</label>
                    <input type="text" placeholder='xxxxxxxx' onChange={(e) => setphone(e.target.value)}></input>
                </div>
            </div>
            <div className='row gdpr-page'>
                <div className='column medium-6 small-12'> 
                    <button className='button' onClick={() => ValidateAndSendLink()}>{translate("coptikk.gdprapproval.obtainconsent")}</button>
                </div>
            </div>
            {sentSuccess &&
                <div className='logincodesent'>
                    {translate("coptikk.adminportal.gdprapproval.linksentsuccess")}
                </div>
            }
        </Fragment>
    )
}

export default GDPRApprovalRequest;